import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';

import { CardMessageDestaqueIpiComponent } from './card-message-destaque-ipi.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        CardMessageDestaqueIpiComponent
    ],
    exports: [
        CardMessageDestaqueIpiComponent
    ]
})
export class CardMessageDestaqueIpiModule { }
